export default __webpack_public_path__ + "static/media/logo_russian_railways.6a3d9f9b.svg";